import _ajax from './ajax';
// let url_pre = 'https://website.xdcdn.net/module/sausage-match/images'
const isTest= new URLSearchParams(location.search).get('env') === 'test' &&
    !location.hostname.includes('.cn');
let domain = isTest ? 'http://39.107.229.24:22102' : 'https://match-sausage.xd.cn';

// 获取直播间地址
const reqVideoLink = () => _ajax(domain + '/api/get_live_url')

// 获取直播信息
const getVideo = link => _ajax(link);

// 获取队伍信息
const reqTeamsList = data => _ajax(domain + '/api/v2.0/match/team-list', data)

const reqTeamInfo = data => _ajax(domain + '/api/v2.0/match/team', data)

// 关注，取消关注
const reqFocusStatus = (token, data) => _ajax(domain + `/api/v2.0/match/user/follow?token=${token}`, data, 'POST')

// 简易赛季列表
const reqMatchSimpleSeasons = data => _ajax(domain + '/api/v2.0/match/simple-seasons', data)

// 获取所有赛程，以及每个赛程划分的阶段
const reqArrangeSeasons = data => _ajax(domain + '/api/v2.0/match/seasons', data)

// 获取服务器时间
const reqcurrentTime = () => _ajax(domain + '/api/v2.0/match/common/time')

// 获取比赛成绩
const reqMatchDetail = data => _ajax(domain + '/api/v2.0/match/team-score', data)

// 获取竞猜赛程列表
const reqScheduleList = data => _ajax(domain + '/api/v2.0/match/quiz/schedule-list', data)

// 获取竞猜信息
const reqQuestionList = data => _ajax(domain + '/api/v2.0/match/quiz/list', data)

// 获取赛程参赛队伍
const reqScheduleTeams = data => _ajax(domain + '/api/v2.0/match/team-list-by-schedule', data)

// 获取赛程战局队列
const reqMatchList = data => _ajax(domain + '/api/v2.0/match/match-list', data)

// 获取在竞猜期间的实时竞猜内容
const reqQuizListLive = () => _ajax('/api/quiz_list_live')

// 竞猜投注
const submitQuiz = (token, data) => _ajax(domain + `/api/v2.0/match/quiz/submit?token=${token}`, data, 'POST')

// 竞猜记录
const reqQuizList = data => _ajax(domain + '/api/v2.0/match/quiz/record', data)

// 获取用户赛事币信息
const reqUserInfo = (data) => _ajax(domain + '/api/v2.0/match/user/info', data)

// 领取每日赛事币  废弃
const receiveGold = (token, data) => _ajax(domain + `/api/v2.0/match/user/receive-gold?token=${token}`, data, 'POST')

// 上报观看时长 
const reportMinutes = (token,data) => _ajax(domain + `/api/v2.0/match/user/report-minutes?token=${token}`, data, 'POST')

// 获取礼物列表
const reqGiftList = (data) => _ajax(domain + '/api/v2.0/match/gift/list',data)

// 获取赛事规则
const reqRule = () => _ajax('https://website.xdcdn.net/module/sausage-match/rule.json')

// 获取商品列表
const reqGoodsList = data => _ajax(domain + '/api/v2.0/match/exchange/list', data)

// 兑换
const submitExchange = (token, data) => _ajax(domain + `/api/v2.0/match/exchange/submit?token=${token}`, data, 'POST')

// 兑换历史
const reqStoreHistory = data => _ajax(domain + '/api/v2.0/match/exchange/record', data)

// 获取名人堂列表
const reqStarList = data => _ajax(domain + '/api/v2.0/match/star-member-list', data)
// 个人五边形数据
const reqStarInfo = data => _ajax(domain + '/api/v2.0/match/member-detail', data)

// 获取赛事中心静态数据
const reqConfig = () => _ajax('https://poster.xdcdn.net/form/website/sausage/match/config.json', {t: new Date().getTime()})

// 实时竞猜
const realTimeGuessing = (token) => _ajax(domain + '/api/v2.0/match/quiz/current-question',{token})

// 赠送礼物
const presentGift= (token,data) => _ajax(domain + `/api/v2.0/match/gift/send?token=${token}`, data,'POST')

// 直接送礼物，上面接口不用 presentGift
const directPresentGift= (token,data) => _ajax(domain + `/api/v2.0/match/gift/direct?token=${token}`, data,'POST')
// 获取背包数据
const getBackpackData = (token) => _ajax(domain + '/api/v2.0/match/gift/list',{token})


const getBuying =  (token,data)=> _ajax(domain + `/api/v2.0/match/gift/exchange?token=${token}`,data,'POST')
// 获取奖金 
const reqPrize = () => _ajax('https://poster-api.xd.cn/api/v1.0/reserve/sausage-amount')

// 获取红点状态

const getRedDotState = (data) => _ajax(domain + '/api/v2.0/match/user/red-dot-show',data)


// 提交报名信息
let new_pre = 'https://poster-api.xd.cn/api/v1.0/activity/match'
// if(location.protocol != 'https:') {
//     new_pre = 'http://39.107.229.24:13009/api/v1.0/activity/match'
// }

// 获取活动列表
const getActivityList =(data) => _ajax(domain + '/api/v2.0/match/task/list',data)

//领取活动奖励  
const getActivityReward =(token,data) => _ajax(domain + `/api/v2.0/match/task/receive?token=${token}`,data,'POST') 

// 助威列表
const  getCheerForList = data => _ajax(domain + '/api/v2.0/match/gift/team-list',data)

// 更新玩家头像
const  updateUseavatar = (token,data) => _ajax(domain + `/api/v2.0/match/user/update-avatar?token=${token}`,data,'POST')

// 排行榜 获取排行榜
const  getTeamRanking = data => _ajax(domain + '/api/v2.0/match/gift/team-total-rank',data)
// 排行榜 获取个人排行榜
// const  getPersonalRanking = (data) => _ajax('/api/v2.0/match/gift/total-rank',data)

// 排行榜 获取个人总排行榜
const  getPersonalRanking = token=> _ajax(domain + `/api/v2.0/match/gift/person-rank?token=${token}`)

// 战队详细粉丝排行
// const  getGiftTeamList = token => _ajax(`/api/v2.0/match/gift/team-rank?token=${token}`)

// 战队排行榜
const  getGiftTeamList = token => _ajax(domain + `/api/v2.0/match/gift/team-rank?token=${token}`)

// 战队详情榜
const  getGiftTeamDetail = (data) => _ajax(domain + '/api/v2.0/match/gift/team-supporter',data)
// 直播页当前比赛个人总排行
// const getLivePersonalRanking = token => _ajax(`/api/v2.0/match/gift/rank?token=${token}`)

// 人气排行榜
// const getLivePersonalRanking = token =>  _ajax(`/api/v2.0/match/gift/team-total-rank?token=${token}`)

// 战队个人送礼
const userInFopersonal = (data) => _ajax(domain + '/api/v2.0/match/gift/rank-value',data);

// 个人送礼
const userPersonalRankValue = (data) => _ajax(domain + '/api/v2.0/match/gift/personal-rank-value',data);


// 每日任务：
const getTaskList = (token) => _ajax(domain + `/api/v2.0/match/task/daily-list?token=${token}`)

const submit = (token, data) => _ajax(`${new_pre}/submit?token=${token}`, data, 'POST');
const agreeNotic = token => _ajax(`${new_pre}/agree?token=${token}`, {}, 'POST');
const reqApplyInfo = data => _ajax(`${new_pre}/status`, data);
const reqNick = data => _ajax(`${new_pre}/nick`, data);

export {
    reqVideoLink,
    getVideo,
    reqTeamsList,
    reqTeamInfo,
    reqFocusStatus,
    reqMatchSimpleSeasons,
    reqArrangeSeasons,
    reqcurrentTime,
    reqMatchDetail,
    reqScheduleList,
    reqQuestionList,
    reqScheduleTeams,
    reqMatchList,
    reqQuizListLive,
    submitQuiz,
    reqQuizList,
    reqUserInfo,
    receiveGold,
    reportMinutes,
    reqRule,
    reqGoodsList,
    submitExchange,
    reqStoreHistory,
    reqStarList,
    reqStarInfo,
    reqConfig,
    submit,
    agreeNotic,
    reqApplyInfo,
    reqNick,
    realTimeGuessing,
    getActivityList,
    getActivityReward,
    getCheerForList,
    updateUseavatar,
    presentGift,
    getBackpackData,
    getBuying,
    getTeamRanking,
    getPersonalRanking,
    getGiftTeamList,
    // getLivePersonalRanking,
    reqPrize,
    userInFopersonal,
    userPersonalRankValue,
    directPresentGift,
    getGiftTeamDetail,
    reqGiftList,
    getRedDotState,
    getTaskList
}